/**
 * Where a completed sign-up or sign-in should land — the entry surface's half
 * of a decision Agent 4 owns.
 *
 * Plan §7 gives final routing to the integration agent, so this file states the
 * intent as a type rather than performing it: the entry pages read these paths,
 * and the application host may pass its own `destinations` (or an `onSuccess`
 * callback, which wins outright) without either side guessing at the other.
 *
 * The value it fixes is a real defect, not a preference. Password sign-in used
 * to send the browser to `/`, the public introduction — so an email user who
 * had just created an account was returned to the marketing page and had to
 * find the workspace themselves. Plan §9 requires the opposite: "Email sign-up
 * reaches an explorable guided workspace without requiring a wallet."
 */

export interface EntryDestinations {
  /** After email/password sign-up or sign-in, and after Google. */
  afterEmailEntry: string
  /** After a signed Keplr/Leap challenge. */
  afterWalletEntry: string
}

/**
 * Both stages end on the same screen on purpose. The workspace is one product
 * in two states, not two dashboards, so activation changes what the Overview
 * can show rather than where the user is sent.
 */
export const ENTRY_DESTINATIONS: EntryDestinations = {
  afterEmailEntry: '/app/',
  afterWalletEntry: '/app/',
}
